import { render, staticRenderFns } from "./RatingModal.vue?vue&type=template&id=72f55e29&scoped=true"
import script from "./RatingModal.vue?vue&type=script&lang=js"
export * from "./RatingModal.vue?vue&type=script&lang=js"
import style0 from "./RatingModal.vue?vue&type=style&index=0&id=72f55e29&prod&lang=scss&scoped=true"
import style1 from "./RatingModal.vue?vue&type=style&index=1&id=72f55e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f55e29",
  null
  
)

/* custom blocks */
import block0 from "./RatingModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports